import classNames from 'classnames';
import { ReactNode, useEffect, useRef } from 'react';
import styles from './AutoSizeText.module.scss';

export type AutoSizeTextProps = {
  className?: string;
  children: ReactNode;
};

export const AutoSizeText = ({ className, children }: AutoSizeTextProps) => {
  const parentRef = useRef<HTMLDivElement>(null);
  const valueRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const maxWidth = parentRef.current?.clientWidth;
    const width = valueRef.current?.offsetWidth;
    if (!maxWidth || !width) return;

    const r = maxWidth / width;
    const scale = Math.min(1, r);
    valueRef.current.style.transform = `scale(${scale})`;
  }, [children, parentRef, valueRef]);

  return (
    <div ref={parentRef} className={classNames(styles.root, className)}>
      <span ref={valueRef} className={styles.inner}>
        {children}
      </span>
    </div>
  );
};
